export default {
    title: "EvaluationSystem",
    footer: ["Interview Management Expert", "A great helper for large-scale interviews", "Version{version}"],
    footerBoc: ["Bank of China Interview Scoring System"],
    placeholder: {
        account: "account",
        password: "password",
    },
    login: "login",
    detectionTips: "If there is a video schedule, please perform ",
    detectionButton: "device testing",
    oidRequiredMsg: "The login link is missing oid. Please use a valid login link",
    failMsg: "User name or password error, please try again",
};
